import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {ApiEvsService} from 'app/common/services/ApiEvs.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Headers, Http} from '@angular/http';

@Injectable()
export class ProductRoadmapService {
  headers: Headers;
  url = environment.qrcode_url;

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  getList(historyId, query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/distributor/history/${historyId}/warning`, {
        headers: this.headers,
        params: query,
      })
      .map((res: any) => res.json())
      .catch((err: any) => {
        throw this.apiEvsService.checkErr(err);
      });
  }

  distributeDetail(id): Observable<any> {
    return this.http
      .get(`${this.url}/distributor/history/${id}`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  distributeHistory(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/distributor/history`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  statisticHistory(id): Observable<any> {
    return this.http
      .get(`${this.url}/distributor/history/${id}/statistic`, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  getSupplier(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/agencies/superior`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  historyPackage(historyId, query?: any): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .get(`${this.url}/distributor/history/${historyId}/package`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  // Thu hồi nhiều
  validateWithdrawal(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/take_back/validate`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  withdrawal(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/stamp/take_back/v2`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  // Thu hồi

  takeBack(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/stamp/take_back`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  // hủy giao dịch
  cancelStamp(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer_stamp/cancel`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // Xác nhận
  confirm(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/stamp/confirm`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  // Trả hàng
  return(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/transfer/request/return`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  listBoxType(): Observable<any> {
    return this.http
      .get(`${this.url}/box/type`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  update(transferId, body?: any): Observable<any> {
    return this.http
      .put(`${this.url}/distributor/history/${transferId}`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  detailStamp(id): Observable<any> {
    return this.http
      .get(`${this.url}/mobile/scan/decode?code=${id}`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  /** Lịch sử xuất/nhập hàng */
  statisticHistoryProduct(query): Observable<any> {
    return this.http
      .get(`${this.url}/distribution/history/statistic?transferId=${query}`, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  getListSerialActiveGuarannte(id): Observable<any> {
    return this.http
      .get(`${this.url}/transfer/${id}/bundle_item`, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/productRoadmap/services/productRoadmap.service.ts